import SeeAllSlide from './SeeAllSlide';
import { default as Slider, Props as SliderProps } from './Slider';
import DefaultNextButton from './lego/DefaultNextButton';
import DefaultPreviousButton from './lego/DefaultPreviousButton';

export {
  SeeAllSlide,
  type SliderProps,
  DefaultPreviousButton,
  DefaultNextButton,
};
export default Slider;
